import MutateJobCategoryDialog from './MutateJobCategoryDialog';

export default MutateJobCategoryDialog;
